import { ExportStatus, useExportStore } from '@/store/export-store'
import useAudioEngine from '@/composables/UseAudioEngine'

export function useTransportEngine () {
  const exportStore = useExportStore()
  const { getAudioContextCurrentTime, loopStartTime } = useAudioEngine()

  // gets the audio current time or the elapsed export seconds
  const getCurrentTransportTime = (): number => {
    const currentTransportTime = (exportStore.exportStatus === ExportStatus.EXPORTING) ? (exportStore.elapsedMilliseconds / 1000) : getAudioContextCurrentTime()
    return currentTransportTime + loopStartTime.value
  }

  // gets the time elapsed uniform input value for the fiters
  const getElapsedTime = (startTime: number): number => {
    if (exportStore.exportStatus === ExportStatus.EXPORTING) {
      return exportStore.elapsedMilliseconds / 1000
    }
    
    return getTimeUnixTimestamp() - startTime
  }

  // gets the current timestamp
  const getTimeUnixTimestamp = (): number => {
    return new Date().getTime() / 1000
  }

  return {
    getCurrentTransportTime,
    getElapsedTime,
    getTimeUnixTimestamp
  }
}